const initialFilters = {
    searchFilters: {},
    pagination: {
        currentPage: 1,
        pageSize: 5,
    },
    refreshIndex: 0
};


export const initialState = {
    items: [],
    totalCount: 0,
    filters: initialFilters,
    isLoading: false,
    itemSelected: null,
};


export const reducer = (state, action) => {
    switch (action.type) {
        case "set_loading":
            return { ...state, isLoading: action.payload };
        case "set_items":
            return { ...state, items: action.payload.items, totalCount: action.payload.total };
        case "set_search_filters":
            return { ...state, filters: { ...state.filters, searchFilters: action.payload } };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } }
        default:
            return state;
    }
};